export const TAB_GROUP_NAMES = {
  DETAILS: 'Details',
  BENEFITS: 'Benefits',
  SPECIFICATIONS: 'Specifications',
  ASSETS: 'Assets'
};

export const KALTURA = {
  WID: '_1614541',
  UICONF_ID: 32121831
}

export const ALL_PRODUCTS = 'All products';

export const MAX_BENEFITS_COUNT = 6;